<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-8">
                <div class="text-white p-3">
                  <h5 class="text-white">Profile {{ $t("malware.user") }}</h5>
                  <p>-</p>
                </div>
              </div>
              <div class="col-4 text-right p-2 px-4">
                <router-link to="/profile/update"
                  ><button class="btn btn-sm btn-primary">
                    <i class="bx bx-pencil bx-xs"></i></button
                ></router-link>

                <router-link to="/profile/setting" class="ml-2"
                  ><button class="btn btn-sm btn-primary">
                    <i class="bx bx-cog bx-xs"></i></button
                ></router-link>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-4">
                <div class="avatar-md profile-user-wid mb-3">
                  <img
                    :src="urlImage + user_profile.avatar"
                    class="img-thumbnail rounded-circle"
                    alt="avatar"
                    v-if="user_profile.avatar"
                  />

                  <img
                    src="@/assets/images/users/avatar-10.jpg"
                    class="img-thumbnail rounded-circle"
                    alt="avatar"
                    v-else
                  />
                </div>
                <h5 class="font-size-15 text-truncate">
                  {{ user_profile.name }}
                </h5>
                <!-- <b class=" badge badge-success p-2 pill">
                   Role : Analys
                  </b> -->
                <span
                  class="badge badge-secondary p-1 px-1 badge-md rounded"
                  variant="secondary"
                  v-if="user_profile.role == 'admn'"
                >
                  Admin</span
                >
                <span
                  class="badge badge-info p-1 px-1 rounded"
                  v-else-if="user_profile.role == 'anly'"
                >
                  {{ $t("dashboards.analyst") }}</span
                >
                <span
                  class="badge badge-success p-1 px-1 rounded"
                  v-else-if="user_profile.role == 'verf'"
                >
                  {{ $t("dashboards.verifier") }}</span
                >
                <span v-else> {{ user_profile.role }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">
              {{ $t("malware.personal-information") }}
            </h4>
            <div class="table-responsive mb-0">
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">{{ $t("user-management.name") }}</th>
                    <td>{{ user_profile.name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.username") }}</th>
                    <td>{{ user_profile.username }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.email") }}</th>
                    <td>{{ user_profile.email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("user-management.last_login") }}</th>
                    <td>{{ user_profile.last_login }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("table.created_at") }}</th>
                    <td>{{ user_profile.created_at }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ $t("table.updated_at") }}</th>
                    <td>{{ user_profile.updated_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">
              {{ $t("verification.two-step-verification") }}
            </h4>
            <table class="table">
              <tbody>
                <tr>
                  <th scope="row">{{ $t("user-management.email") }}</th>
                  <td>
                    <span v-if="user_profile.is_active_2fa">{{
                      user_profile.tfa.tfa_email
                    }}</span>
                    <span v-else>-</span>
                  </td>
                </tr>

                <tr>
                  <th scope="row">{{ $t("verification.last-updated") }}</th>
                  <td>
                    <span v-if="user_profile.is_active_2fa">{{
                      user_profile.last_update_2fa
                    }}</span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">{{ $t("malware.log-activity") }}</h4>
            <div class="table-responsive mb-4">*cooming soon</div>
          </div>
        </div>
        <!-- end card -->
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div
          class="row"
          v-if="user_profile.role == 'admn' || user_profile.role == 'anly'"
        >
          <div v-for="stat of statDataAdmin" :key="stat.icon" class="col-12">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>
        <div class="row" v-if="user_profile.role == 'verf'">
          <div v-for="stat of statData" :key="stat.icon" class="col-12">
            <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
          </div>
        </div>

        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body" v-if="!loading && tableData[0]">
                  <h5>{{ $t("malware.history-report") }}</h5>
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          {{ $t("table.show_label") }}&nbsp;&nbsp;
                          <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                            class="mx-1"
                          ></b-form-select
                          >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-right"
                      >
                        <label class="d-inline-flex align-items-center">
                          {{ $t("table.search_label") }}:
                          <b-form-input
                            v-model="filter"
                            type="search"
                            :placeholder="$t('navbar.search.text')"
                            class="form-control form-control-sm ml-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                  <!-- Table -->
                  <div class="table-responsive mb-0">
                    <b-table
                      :items="tableData"
                      :fields="fields"
                      responsive="sm"
                      striped
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                    >
                      <template #cell(username)="row">
                        <!-- {{row.item.avatar }} -->
                        <!-- <img
                              src="@/assets/images/users/avatar-10.jpg"
                              class="mr-3 rounded-circle avatar-xs"
                              alt="user-pic"
                            /> -->
                        <img
                          :src="urlImage + row.item.avatar"
                          class="rounded-circle header-profile-user"
                          alt="avatar"
                          v-if="row.item.avatar"
                        />
                        <img
                          src="@/assets/images/users/avatar-10.jpg"
                          class="rounded-circle header-profile-user"
                          alt="avatar"
                          v-else
                        />
                        {{ row.item.username }}
                      </template>
                      <template #cell(status_report)="row">
                        <span
                          v-if="row.item.status_report === '3'"
                          class="badge badge-success rounded"
                          >Valid</span
                        >
                        <span
                          v-if="row.item.status_report === '2'"
                          class="badge badge-danger rounded"
                          >Not Valid</span
                        >
                        <span
                          v-if="row.item.status_report === '1'"
                          class="badge badge-info rounded"
                          >Pending</span
                        >
                        <span
                          v-if="row.item.status_report === '0'"
                          class="badge badge-warning rounded"
                          >Draft</span
                        >
                      </template>
                      <template #cell(description)="row">
                        <span v-if="row.item.description"
                          >{{ row.item.description.substring(0, 80) }}
                        </span>
                        <span v-if="row.item.description.length > 80">..</span>
                      </template>
                      <template #cell(created_at)="row">
                        <span>{{ formatDate(row.item.created_at) }}</span>
                      </template>
                      <template #cell(actions)="row">
                        <router-link
                          :to="{
                            path: '/malware/detail-report',
                            query: { id: getId(row.item.id_report) },
                          }"
                        >
                          <b-button class="mr-1" variant="success" size="sm"
                            >Detail</b-button
                          >
                        </router-link>
                      </template>
                    </b-table>
                  </div>
                  <div class="row" v-if="rows > 10">
                    <div class="col-2">
                      <!-- <div v-if="selected[0]">
                                <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                              </div> -->
                      <label class="d-inline-flex align-items-center">
                        Page
                        <b-form-input
                          v-model="currentPage"
                          placeholder="Page"
                          class="form-control w-10 form-control ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                    <div class="col-10 text-right" v-if="rows > 10">
                      <div
                        class="dataTables_paginate paging_simple_numbers float-right"
                      >
                        <ul
                          class="pagination pagination-rounded mb-0"
                          :class="
                            theme == 'dark'
                              ? 'custom-paginate-dark'
                              : 'custom-paginate'
                          "
                        >
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body" v-if="loading && !tableData[0]">
                  <div class="row">
                    <div class="col-12 text-center align-item-center m-5 p-5">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <div>
                        <span>Loading..</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div
                  class="card-body"
                  v-if="!loading && tableDataVerification[0]"
                >
                  <h5>{{ $t("malware.history-verification") }}</h5>
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          {{ $t("table.show_label") }}&nbsp;&nbsp;
                          <b-form-select
                            v-model="perPageVerif"
                            size="sm"
                            :options="pageOptionsVerif"
                            class="mx-1"
                          ></b-form-select
                          >&nbsp;&nbsp;{{ $t("table.entri_label") }}
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-right"
                      >
                        <label class="d-inline-flex align-items-center">
                          {{ $t("table.search_label") }}:
                          <b-form-input
                            v-model="filterVerif"
                            type="search"
                            :placeholder="$t('navbar.search.text')"
                            class="form-control form-control-sm ml-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                  <!-- Table -->
                  <div class="table-responsive mb-0">
                    <b-table
                      :items="tableDataVerification"
                      :fields="fields"
                      responsive="sm"
                      striped
                      :per-page="perPageVerif"
                      :current-page="currentPageVerif"
                      :sort-desc.sync="sortDescVerif"
                      :filter="filterVerif"
                      :filter-included-fields="filterOnVerif"
                      @filtered="onFilteredVerif"
                    >
                      <template #cell(username)="row">
                        <img
                          :src="urlImage + row.item.avatar"
                          class="rounded-circle header-profile-user"
                          alt="avatar"
                          v-if="row.item.avatar"
                        />
                        <img
                          src="@/assets/images/users/avatar-10.jpg"
                          class="rounded-circle header-profile-user"
                          alt="avatar"
                          v-else
                        />
                        {{ row.item.username }}
                      </template>
                      <template #cell(description)="row">
                        <span v-if="row.item.description"
                          >{{ row.item.description.substring(0, 80) }}
                        </span>
                        <span v-if="row.item.description.length > 80">..</span>
                      </template>
                      <template #cell(status_report)="row">
                        <span
                          v-if="row.item.status_report === '3'"
                          class="badge badge-success rounded"
                          >Valid</span
                        >
                        <span
                          v-if="row.item.status_report === '2'"
                          class="badge badge-danger rounded"
                          >Not Valid</span
                        >
                        <span
                          v-if="row.item.status_report === '1'"
                          class="badge badge-info rounded"
                          >Pending</span
                        >
                        <span
                          v-if="row.item.status_report === '0'"
                          class="badge badge-warning rounded"
                          >Draft</span
                        >
                      </template>
                      <template #cell(created_at)="row">
                        <span>{{ formatDate(row.item.created_at) }}</span>
                      </template>
                      <template #cell(actions)="row">
                        <router-link
                          :to="{
                            path: '/malware/detail-report',
                            query: { id: getId(row.item.id_report) },
                          }"
                        >
                          <b-button class="mr-1" variant="success" size="sm"
                            >Detail</b-button
                          >
                        </router-link>
                      </template>
                    </b-table>
                  </div>
                  <div class="row" v-if="rows > 10">
                    <div class="col-2">
                      <!-- <div v-if="selected[0]">
                                <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                              </div> -->
                      <label class="d-inline-flex align-items-center">
                        Page
                        <b-form-input
                          v-model="currentPage"
                          placeholder="Page"
                          class="form-control w-10 form-control ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                    <div class="col-10 text-right" v-if="rowsVerif > 10">
                      <div
                        class="dataTables_paginate paging_simple_numbers float-right"
                      >
                        <ul
                          class="pagination pagination-rounded mb-0"
                          :class="
                            theme == 'dark'
                              ? 'custom-paginate-dark'
                              : 'custom-paginate'
                          "
                        >
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-body"
                  v-if="loading && !tableDataVerification[0]"
                >
                  <div class="row">
                    <div class="col-12 text-center align-item-center m-5 p-5">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <div>
                        <span>Loading..</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="card-body"> -->
          <!-- <h4 class="card-title mb-4">Log Activity</h4>
            <div class="table-responsive mb-0">
              <table class="table table-nowrap table-hover">
                <thead>
                  <tr>
                    <th scope="col">ID Log</th>
                    <th scope="col">IP Source</th>
                    <th scope="col">Request</th>
                    <th scope="col">Time Activity</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">20012</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-success">GET (200) </span> <br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                  <tr>
                    <th scope="row">20013</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-warning">POST (200) </span> <br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                  <tr>
                    <th scope="row">20014</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-success">GET (200) </span><br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                  <tr>
                    <th scope="row">20015</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-warning">POST (200)</span><br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                  <tr>
                    <th scope="row">20016</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-danger">DELETE (200) </span><br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                  <tr>
                    <th scope="row">20017</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-danger">DELETE (200) </span><br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                  <tr>
                    <th scope="row">20018</th>
                    <td>20.20.20.147</td>
                    <td>
                      <span class="text-success">GET (200) </span><br />
                      Req Url : http://xbit-dashboard.xyz/api/profile/365
                    </td>
                    <td>2022-12-23, 13:52:43</td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import appConfig from "@/app.config";
import moment from "moment";
import { revenueChart } from "./data-profile";
import Stat from "@/components/widgets/stat";
import { userService } from "@/helpers/authservice/user.service";
import { notificationMethods } from "@/state/helpers";

export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      revenueChart: revenueChart,
      title: "Profile",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Profile",
          active: true,
        },
      ],
      loading: false,
      total_report: "-",
      total_verification: "-",
      tableData: [],
      tableDataVerification: [],
      theme: localStorage.getItem("theme") ?? "light",
      user_profile: {
        id_user: "",
        username: "",
        email: "",
        name: "",
        role: "",
        avatar: "",
        last_login: "",
        created_at: "",
        updated_at: "",
        is_active_2fa: "",
        last_update_2fa: "",
        tfa: "",
      },
      statData: [
        {
          icon: "bx bx-check-circle",
          title: "Total " + this.$t("dashboards.verification"),
          value: "-",
        },
      ],

      statDataAdmin: [
        {
          icon: "bx bxs-report",
          title: "Total " + this.$t("dashboards.report"),
          value: "-",
        },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      totalRowsVerif: 1,
      currentPageVerif: 1,
      perPageVerif: 10,
      pageOptionsVerif: [10, 25, 50, 100],
      filterVerif: null,
      filterOnVerif: [],
      sortDescVerif: false,

      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        { key: "id_user", thClass: "d-none", tdClass: "d-none" },
        {
          key: "title",
          sortable: true,
          thStyle: { width: "25%" },
          label: this.$t("malware.title"),
        },
        {
          key: "description",
          thStyle: { width: "25%" },
          sortable: true,
          label: this.$t("malware.description"),
        },
        {
          key: "risk_score",
          sortable: true,
          label: this.$t("malware.risk-score"),
        },
        {
          key: "status_report",
          sortable: true,
          label: this.$t("malware.status-report"),
        },
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },

        {
          key: "created_at",
          sortable: true,
          label: this.$t("table.created_at"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("table.action"),
        },
      ],
    };
  },
  mounted() {
    this.getUser();
    this.totalRows = this.items.length;
    this.totalRowsVerif = this.items.length;
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rowsVerif() {
      return this.tableDataVerification.length;
    },
  },
  methods: {
    getUser() {
      let ferr = 0;
      UserService.profileUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let val = response.data.data;
            this.user_profile.id_user = val.id_user;
            this.user_profile.username = val.username;
            this.user_profile.email = val.email;
            this.user_profile.name = val.name;
            this.user_profile.role = val.role ?? "-";
            this.user_profile.avatar = val.avatar ?? "";
            this.user_profile.last_login = val.last_login ?? "-";
            this.user_profile.created_at = this.formatDate(val.created_at);
            this.user_profile.updated_at = this.formatDate(val.updated_at);
            this.user_profile.is_active_2fa = val.is_active_2fa;
            this.user_profile.last_update_2fa = this.formatDate(
              val.last_update_2fa
            );
            this.user_profile.tfa = val.tfa;

            const report = response.data.data.report;
            const verification = response.data.data.verification;

            if (report[0]) {
              this.statDataAdmin[0].value = report.length ?? "-";
            }

            if (verification[0]) {
              this.statData[0].value = verification.length ?? "-";
            }

            // report.forEach(val => {
            //   if(val.status == 3){
            //     console.log('valid');
            //   } if(val.status == ){
            //     console.log('valid');
            //   }
            // });

            const rp = response.data.data.report;
            if (val.report[0]) {
              rp.forEach((el, idx) => {
                let report = {
                  no: idx + 1,
                  id_report: el.id_report,
                  title: el.title,
                  description: el.description,
                  risk_score: el.risk_score,
                  malware_logo: el.malware_logo ?? "cyber-attack.png",
                  status_report: el.status_report,
                  comments_count: el.comments_count,
                  created_at: el.created_at,
                  malware_data: JSON.parse(el.malware_data),
                  tags: JSON.parse(el.tags),
                  report_by: el.report_by ?? null,
                  verify_by: el.verif_by ?? null,
                };

                // if (el.status_report == 0) {
                //   this.status_report.draft = this.status_report.draft + 1;
                // } else if (el.status_report == 1) {
                //   this.status_report.pending = this.status_report.pending + 1;
                // } else if (el.status_report == 2) {
                //   this.status_report.not_valid =
                //     this.status_report.not_valid + 1;
                // } else if (el.status_report == 3) {
                //   this.status_report.valid = this.status_report.valid + 1;
                // }
                console.log("el", el.created_at);
                this.tableData.push(report);
              });
            }

            let v = val.verification;
            if (val.verification[0]) {
              v.forEach((el, idx) => {
                let verif = {
                  no: idx + 1,
                  id_report: el.id_report,
                  title: el.title,
                  description: el.description,
                  risk_score: el.risk_score,
                  malware_logo: el.malware_logo ?? "cyber-attack.png",
                  status_report: el.status_report,
                  comments_count: el.comments_count,
                  created_at: el.created_at,
                  malware_data: JSON.parse(el.malware_data),
                  tags: JSON.parse(el.tags),
                  report_by: el.report_by ?? null,
                  verify_by: el.verif_by ?? null,
                };

                this.tableDataVerification.push(verif);
              });
            }

            console.log("report", report);
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },

    setId() {
      const id = this.$route.query.id;
      if (id) {
        this.id_user = Buffer.from(id, "base64").toString("ascii");
      }
    },

    getId(id) {
      return Buffer.from(id).toString("base64");
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    onFilteredVerif(filteredItems) {
      this.totalRowsVerif = filteredItems.length;
      this.currentPageVerif = 1;
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },
};
</script>

<style>
.pagination-rounded .page-link {
  outline: none !important;
  margin: 0 2px;
  border: 1px solid #ced4da;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>
